import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { BaseModalComponent } from '../../../../core/layout/components/abstracts/base-modal.component';
import { StaffDashboardPageComponent } from '../../pages/staff-dashboard-page/staff-dashboard-page.component';

@Component({
  selector: 'app-ots-staff-modal',
  standalone: true,
  imports: [ModalComponent, TranslatePipe, StaffDashboardPageComponent],
  templateUrl: './ots-staff-modal.component.html',
  styleUrl: './ots-staff-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OtsStaffModalComponent extends BaseModalComponent {
}
